<template>
  <div class="rn-slider-area" id="home" v-if="NOTARIA && NOTARIA.Theme">
    <div class="slider-style-notin-bg-1 bg_image" style="position: relative; overflow: hidden; height: 100%;">
      <div v-if="img && file?.type !== 'video/mp4'" class="bg_media" :style="backgroundMediaStyle"></div>
      <div class="slide slider-style-notin-1 slider-style-notin-filter-1 slider-paralax paralx-slider parallax d-flex justify-center hardware-aceleration"
           :style="slideStyle" style="position: relative; z-index: 1;">
        <video v-if="file && file.type === 'video/mp4'" class="home-video" :style="videoStyle" :src="imagenIDtoSRC(style.ThemeHomeBanner.Imagen)"
               preload="metadata" muted autoplay playsinline loop />
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="banner-home inner text-left">
                <div class="logo-image" :class="{'d-none d-md-flex': NOTARIA.Theme.Home.Banner.LogoMobile === false}" v-if="NOTARIA.Theme.Home.Banner.Logo && !ModoAccesible" :style="logoBlockStyle">
                  <img class="img" :style="logoImgStyle" 
                      :src="NOTARIA?.Theme?.Home?.Banner?.ImagenLogo?.trim() ? imagenIDtoSRC(NOTARIA.Theme.Home.Banner.ImagenLogo) : '/img/logo-notariado.png'"
                      :alt="'Logo de la ' + NOTARIA.Nombre"
                  />
                  <!-- <img class="img" :style="logoImgStyle" :src="NOTARIA.Theme.Home.Banner.ImagenLogo !== '' ? imagenIDtoSRC(NOTARIA.Theme.Home.Banner.ImagenLogo) : '/img/logo-notariado.png'"
                       alt="Logo notariado"/> -->
                </div>

                <h1 :style="tituloStyle" v-html="NOTARIA.Theme.Home.Banner.Titulo.Texto"></h1>

                <h2 :style="subtituloStyle" v-html="NOTARIA.Theme.Home.Banner.Subtitulo.Texto"></h2>

                <div v-if="NOTARIA.Theme.Home.Banner.Texto" class="banner-home-text"
                    :style="textoStyle" v-html="NOTARIA.Theme.Home.Banner.Texto.Texto"></div>

                <div class="slide-btn content-button" :style="buttonsBlockStyle">
                  <v-btn id="button-menu" v-if="NOTARIA.Theme.Home.Banner.ShowButtonMoveMenu"  class="mx-2 rn-btn" :style="buttonMenuStyle"  @click="goTo(compMenuAction)">
                    {{ NOTARIA.Theme.Home.Banner.ButtonMoveMenu.Texto }}
                  </v-btn>

                  <v-btn id="button-inicio" v-if="NOTARIA.Theme.Home.Banner.ShowButtonMoveInicio" class="mx-2 rn-btn" :style="buttonInicioStyle"
                          @click="scrollMeTo(compInicioAction)">
                    {{ NOTARIA.Theme.Home.Banner.ButtonMoveInicio.Texto }}
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div v-if="NOTARIA?.Theme?.Home?.Banner?.ShowArrow" class="scroll-indicator-classic" @click="handleArrowClick">
        <v-icon :color="style.ThemeHomeBanner?.Titulo?.css?.Color || 'white'">mdi-chevron-down</v-icon>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store'
import { useUtils } from '#imports'
import { navigateTo } from '#app/composables/router'
import { TiposAccionBoton } from '~/helpers/Enums/Enum'
import { useStyles } from '../../store/styles'

const store = useStore()
const { NOTARIA, ModoAccesible } = storeToRefs(store)

const style = useStyles()
const { imagenIDtoSRC, getFile, textToHtml } = useUtils()


const file = computed(() => getFile(style.ThemeHomeBanner?.Imagen))
const imgFiltro = computed(() => style.ThemeHomeBanner?.ImagenFiltro ?? '')
const img = computed(() => file.value && file.value.type !== 'video/mp4' ? `url(${imagenIDtoSRC(style.ThemeHomeBanner?.Imagen)})` : '')


const compMenuAction = computed(() =>
  NOTARIA.value?.Theme?.Home?.Banner?.ButtonMoveMenu ? getTipoAccion(NOTARIA.value.Theme.Home.Banner.ButtonMoveMenu.Click) : null
)

const compInicioAction = computed(() =>
  NOTARIA.value?.Theme?.Home?.Banner?.ButtonMoveInicio ? getTipoAccion(NOTARIA.value.Theme.Home.Banner.ButtonMoveInicio.Click) : null
)
const logoBlockStyle = computed(() => ({
  display: 'flex',
  width: '100%',
  justifyContent: getJustifyContent(style.ThemeHomeBanner?.ImagenLogoBlock?.css?.Align ?? '')
}))

const logoImgStyle = computed(() => ({
  maxWidth: style.ThemeHomeBanner?.ImagenLogoBlock?.css?.Size ?? '',
  height: 'auto'
}))

const tituloStyle = computed(() => ({
  color: style.ThemeHomeBanner?.Titulo?.css?.Color ?? '',
  textShadow: style.ThemeHomeBanner?.Titulo?.css?.BackgroundColor ? `4px 2px 6px ${style.ThemeHomeBanner.Titulo.css.BackgroundColor}` : '',
  fontFamily: style.ThemeHomeBanner?.Titulo?.css?.Font ?? '',
  fontSize: style.ThemeHomeBanner?.Titulo?.css?.Size ?? '',
  fontWeight: style.ThemeHomeBanner?.Titulo?.css?.Weight ?? '',
  textAlign: style.ThemeHomeBanner?.Titulo?.css?.Align ?? ''
}))

const subtituloStyle = computed(() => ({
  color: style.ThemeHomeBanner?.Subtitulo?.css?.Color ?? '',
  textShadow: style.ThemeHomeBanner?.Subtitulo?.css?.BackgroundColor ? `4px 2px 6px ${style.ThemeHomeBanner.Subtitulo.css.BackgroundColor}` : '',
  fontFamily: style.ThemeHomeBanner?.Subtitulo?.css?.Font ?? '',
  fontSize: style.ThemeHomeBanner?.Subtitulo?.css?.Size ?? '',
  fontWeight: style.ThemeHomeBanner?.Subtitulo?.css?.Weight ?? '',
  textAlign: style.ThemeHomeBanner?.Subtitulo?.css?.Align ?? ''
}))

const textoStyle = computed(() => ({
  color: style.ThemeHomeBanner?.Texto?.css?.Color ?? '',
  textShadow: style.ThemeHomeBanner?.Texto?.css?.BackgroundColor  ? `4px 2px 6px ${style.ThemeHomeBanner.Texto.css.BackgroundColor}` : '',
  fontFamily: style.ThemeHomeBanner?.Texto?.css?.Font ?? '',
  fontSize: style.ThemeHomeBanner?.Texto?.css?.Size ?? '',
  fontWeight: style.ThemeHomeBanner?.Texto?.css?.Weight ?? '',
  textAlign: style.ThemeHomeBanner?.Texto?.css?.Align ?? ''
}))

const buttonsBlockStyle = computed(() => {
  const align = style.ThemeHomeBanner?.ButtonsBlock?.css?.Align ?? '';
  return {
    display: 'flex',
    justifyContent: getJustifyContent(align)
  };
})

const buttonMenuStyle = computed(() => ({
  color: style.ThemeHomeBanner?.ButtonMoveMenu?.css?.Color ?? '',
  fontFamily: style.ThemeHomeBanner?.ButtonMoveMenu?.css?.Font ?? '',
  fontWeight: style.ThemeHomeBanner?.ButtonMoveMenu?.css?.Weight ?? '',
  fontSize: style.ThemeHomeBanner?.ButtonMoveMenu?.css?.Size ?? '',
  backgroundColor: style.ThemeHomeBanner?.ButtonMoveMenu?.css?.BackgroundColor ?? '',
  border: style.ThemeHomeBanner?.ButtonMoveMenu?.css?.BorderColor ? `2px solid ${style.ThemeHomeBanner.ButtonMoveMenu.css.BorderColor} !important` : (style.ThemeHomeBanner?.ButtonMoveMenu?.css?.Color ? `2px solid ${style.ThemeHomeBanner.ButtonMoveMenu.css.Color} !important` : ''),
  borderColor: style.ThemeHomeBanner?.ButtonMoveMenu?.css?.BorderColor || style.ThemeHomeBanner?.ButtonMoveMenu?.css?.Color || '',
  borderWidth: '2px',
  borderStyle: 'solid'
}))

const buttonInicioStyle = computed(() => ({
  color: style.ThemeHomeBanner?.ButtonMoveInicio?.css?.Color ?? '',
  fontFamily: style.ThemeHomeBanner?.ButtonMoveInicio?.css?.Font ?? '',
  fontWeight: style.ThemeHomeBanner?.ButtonMoveInicio?.css?.Weight ?? '',
  fontSize: style.ThemeHomeBanner?.ButtonMoveInicio?.css?.Size ?? '',
  backgroundColor: style.ThemeHomeBanner?.ButtonMoveInicio?.css?.BackgroundColor ?? '',
  border: style.ThemeHomeBanner?.ButtonMoveInicio?.css?.BorderColor ? `2px solid ${style.ThemeHomeBanner.ButtonMoveInicio.css.BorderColor} !important` : (style.ThemeHomeBanner?.ButtonMoveInicio?.css?.Color ? `2px solid ${style.ThemeHomeBanner.ButtonMoveInicio.css.Color} !important` : ''),
  borderColor: style.ThemeHomeBanner?.ButtonMoveInicio?.css?.BorderColor || style.ThemeHomeBanner?.ButtonMoveInicio?.css?.Color || '',
  borderWidth: '2px',
  borderStyle: 'solid',
  textAlign: style.ThemeHomeBanner?.ButtonMoveInicio?.css?.Align ?? ''
}))

const slideStyle = computed(() => ({
}))

const backgroundMediaStyle = computed(() => ({
  backgroundImage: img.value,
  filter: imgFiltro.value,
  WebkitFilter: imgFiltro.value
}))

const videoStyle = computed(() => ({
  filter: imgFiltro.value,
  WebkitFilter: imgFiltro.value
}))

function goTo(refName: TiposAccionBoton) {
  if (!refName) return
  if (refName === TiposAccionBoton.NV) {
    navigateTo(NOTARIA.value.NotariaVirtual, { external: true })
  } else if (refName === TiposAccionBoton.Chatbot) {
    store.isChatbotOpen = true
  } else {
    navigateTo(refName.resumen)
  }
}

function scrollMeTo(refName: TiposAccionBoton) {
  if (!refName || refName === TiposAccionBoton.undefined) return
  if (refName === TiposAccionBoton.Chatbot) {
    store.isChatbotOpen = true
    return
  }
  const element =
    document.getElementById(refName.name) ||
    document.querySelector(refName.name)
  if (element) window.scrollTo({ top: element.offsetTop - 80, behavior: 'smooth' })
}

function scrollToNextSection() {
  const nextSection = document.querySelector('.home-section');
  if (nextSection) {
    window.scrollTo({
      top: nextSection.offsetTop - 80,
      behavior: 'smooth'
    });
  }
}

function handleArrowClick() {
  const actionName = NOTARIA.value?.Theme?.Home?.Banner?.ArrowAction;
  if (actionName) {
    const action = getTipoAccion(actionName);
    scrollMeTo(action);
  } else {
    scrollToNextSection();
  }
}

function getJustifyContent(align: string) {
  if (!align) return 'flex-start';
  const a = align.toLowerCase();
  if (a.includes('cent') || a.includes('mitte') || a.includes('mid')) return 'center';
  if (a.includes('right') || a.includes('end') || a.includes('derech') || a.includes('dret') || a.includes('droit') || a.includes('destr') || a.includes('direit') || a.includes('rechts')) return 'flex-end';
  if (a.includes('left') || a.includes('start') || a.includes('izquierd') || a.includes('esquerr') || a.includes('gauch') || a.includes('sinistr') || a.includes('links')) return 'flex-start';
  return align;
}

function getTipoAccion(value: string) {
  switch (value) {
    case 'about':
      return TiposAccionBoton.Notario
    case 'service':
      return TiposAccionBoton.Servicios
    case 'blog':
      return TiposAccionBoton.Blog
    case 'testimonial':
      return TiposAccionBoton.Testimonial
    case 'homegallery':
      return TiposAccionBoton.Gallery
    case 'Inicio':
      return TiposAccionBoton.Inicio
    case 'contact':
      return TiposAccionBoton.Contacto
    case 'NV':
      return TiposAccionBoton.NV
    case 'equipo':
      return TiposAccionBoton.Equipo
    case 'chatbot':
      return TiposAccionBoton.Chatbot
    default:
      return TiposAccionBoton.undefined
  }
}
</script>

<style scoped lang="scss">
.banner-home .logo-image {
  display: flex;
}
.banner-home {
  margin-top: 64px; 
}
.slide {
  position: relative;
  min-height: calc(100vh - 64px);
}

.home-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
}
@media (max-width: 600px) {
  .slide-btn {
    flex-direction: column;
    align-items: center;
  }

  .slide-btn .v-btn {
    margin: 6px 0 !important;
    width: 100%;
    max-width: 280px;
  }
}
.bg_media {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  z-index: 0;
}
.rn-btn {
  text-transform: none !important;
}
.scroll-indicator-classic {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  z-index: 10;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {transform: translateX(-50%) translateY(0);}
  40% {transform: translateX(-50%) translateY(-10px);}
  60% {transform: translateX(-50%) translateY(-5px);}
}
</style>
